// NOTE: HubSpotのトラッキングコードがページに埋め込まれている必要がある
export const extractHubspotTrackingCodeFromCookie = (): string | null => {
  const a = document.cookie.match(/hubspotutk=([a-z0-9]+)/);
  if (a === null) return null;
  return a[0].replace(/^hubspotutk=/, '') || null;
};
